import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatImage } from '../../../../base/publicMethod/index';
import { getImageUrl, imageAttr } from '../utils/image';
import classNames from '../utils/classNames';
import formatTime from '../utils/formatTime';
import styles from '../styles/styles.css';
import imageUrl from './imageUrl';
import { handleCallNewsApp, h5PageCount } from '../../../../utils';
import { formatPlayNum } from '../utils/playNumUnit';
import { callVideoAPP } from '../utils/callVideoApp';
import { formatVideoDuration } from '../utils/formatVideoDuration';
import Observer from '@researchgate/react-intersection-observer';

/* 一图模式 */
class VideoImage extends PureComponent {
    static propTypes = {
        item: PropTypes.object,
        index: PropTypes.number,
        url: PropTypes.string,
        // pinglunUrl: PropTypes.string,
        countMapCache: PropTypes.object,
        isDisplaySource: PropTypes.bool,
        isCount: PropTypes.bool,
        isNewsTime: PropTypes.bool,
        isLazyImage: PropTypes.bool,
        isFormatTime: PropTypes.bool,
        isClickListItem: PropTypes.bool,
        videoSource: PropTypes.string,
        getExposureData: PropTypes.func,
    };

    static defaultProps = {
        isDisplaySource: true,
        isCount: true,
        isNewsTime: true,
        isFormatTime: true,
        isClickListItem: false,
    };

    handleClick = (url, id, newstype, kind, clickCountConfig) => {
        const { videoSource } = this.props;
        const nodata = '';
        const doc_type = newstype;
        const aid = id;
        const to_url = url;

        this.feedClickCountFn(clickCountConfig);
        if (videoSource === 'ifengVideos') {
            callVideoAPP({
                scheme: {
                    type: 'video',
                    guid: id,
                    id,
                    channel: 'h5',
                },
            });
        } else {
            handleCallNewsApp(nodata, doc_type, aid, to_url, 0, 0, kind);
        }
    };

    feedClickCountFn = config => {
        if (config) {
            h5PageCount([config]);
        }
    };

    observerHandle = (event, unobserve) => {
        const { item } = this.props;
        const expCountConfig = item && item.expCountConfig;

        if (event.isIntersecting && expCountConfig) {
            unobserve();
            this.props.getExposureData([expCountConfig]);
        }
    };

    render() {
        const {
            url, // 拉起客户端需要
            item,
            index,
            isLazyImage,
            isFormatTime,
            isClickListItem,
        } = this.props;
        const {
            title,
            imageList,
            infoId,
            clickCount, // 拉起客户端需要
            kind, // 拉起客户端
        } = item;
        const width = imageAttr(115);
        const height = imageAttr(76);
        const props = { width, height, alt: title };
        const clickCountConfig = clickCount ? clickCount : '';
        const id = infoId || item.memberItem.guid;
        const to_url = url;
        let image = imageList && imageList.length > 0 ? imageList : '';

        // thumbnails
        if (image && typeof image === 'object' && 'image' in image[0]) {
            image = image[0].image;
        }
        // console.log(image);

        const src = formatImage(image, 115, 76);

        if (isLazyImage) {
            props.src = imageUrl.normal;
            props['data-lazy-src'] = src;
        } else {
            props.src = src;
        }

        const callUp = index === 3 || index === 4 ? 1 : false;

        return (
            <Observer onChange={this.observerHandle}>
                <div
                    className={classNames(styles.flex, styles.listItem)}
                    data-list-item
                    onClick={
                        isClickListItem
                            ? this.handleClick.bind(this, to_url, id, 'phvideo', kind, clickCountConfig)
                            : () => {}
                    } // 分享页加点击体验
                >
                    <div className={classNames(styles.mt4, styles.col1)}>
                        <h4 className={classNames(styles.oneImageBox, styles.title)}>
                            {callUp && (
                                <a onClick={this.handleClick.bind(this, to_url, id, 'phvideo', kind, clickCountConfig)}>
                                    {title}
                                </a>
                            )}
                            {!callUp && (
                                <a onClick={this.feedClickCountFn.bind(this, clickCountConfig)} href={url}>
                                    {title}
                                </a>
                            )}
                        </h4>
                        <p className={`${styles.p} ${callUp ? styles.recommendp : ''}`}>
                            {callUp && <span className={styles.H5recommendLogo} />}
                            <span className={styles.videoCreater}>{item.weMedia.name}</span>
                            <span>
                                {formatPlayNum(Number(item.memberItem.playTime ? item.memberItem.playTime : 0))}次播放
                            </span>
                        </p>
                    </div>
                    {callUp ? (
                        <a
                            className={classNames(styles.ml24, styles.noshrink, styles.aLink)}
                            style={{ backgroundImage: `url('${imageUrl.normal}')` }}
                            onClick={this.handleClick.bind(this, to_url, id, 'phvideo', kind, clickCountConfig)}>
                            <img {...props} />
                            {isFormatTime ? (
                                <div className={styles.videoLength}>
                                    {formatVideoDuration(item.memberItem.duration)}
                                </div>
                            ) : null}
                        </a>
                    ) : (
                        <a
                            onClick={this.feedClickCountFn.bind(this, clickCountConfig)}
                            className={classNames(styles.ml24, styles.noshrink, styles.aLink)}
                            style={{ backgroundImage: `url('${imageUrl.normal}')` }}
                            href={url}>
                            <img {...props} />
                            {isFormatTime ? (
                                <div className={styles.videoLength}>
                                    {formatVideoDuration(item.memberItem.duration)}
                                </div>
                            ) : null}
                        </a>
                    )}
                </div>
            </Observer>
        );
    }
}

export default VideoImage;
